import {
  HOLD_REASON_LABEL, STATUS_LABEL, TICKET_TYPE_LABEL,
  type HoldReason, type Priority, type TicketStatus, type TicketType
} from '@veta-desk/domain';

// Prioridades: además del color, difieren en claridad y llevan texto (no solo color).
const PRIORITY_STYLE: Record<Priority, string> = {
  P1: 'bg-[#8F1D1D] text-white',
  P2: 'bg-[#F6C99A] text-[#5A2C00]',
  P3: 'bg-[#DCE7F7] text-[#173B6E]',
  P4: 'bg-[#EDEBE7] text-[#3F3D39]'
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span className={`rounded px-2 py-0.5 font-mono text-xs font-semibold ${PRIORITY_STYLE[priority]}`}>{priority}</span>
  );
}

export function TypeBadge({ type }: { type: TicketType }) {
  return (
    <span title={TICKET_TYPE_LABEL[type]} className="rounded border border-[#C9C7C2] px-2 py-0.5 font-mono text-xs font-medium">
      {type}
    </span>
  );
}

const STATUS_TONE: Partial<Record<TicketStatus, string>> = {
  new: 'text-[#173B6E]',
  pending_approval: 'text-[#8A4B00]',
  on_hold: 'text-[#8A4B00]',
  resolved: 'text-accent',
  closed: 'text-muted',
  cancelled: 'text-muted',
  rejected: 'text-muted',
  converted: 'text-muted'
};

export function StatusText({ status, holdReason, holdNote }: { status: TicketStatus; holdReason?: HoldReason | null; holdNote?: string | null }) {
  return (
    <span className={`font-medium ${STATUS_TONE[status] ?? 'text-ink'}`}>
      <span className="whitespace-nowrap">{STATUS_LABEL[status]}</span>
      {status === 'on_hold' && holdReason ? <span className="block text-xs font-normal text-muted">{HOLD_REASON_LABEL[holdReason]}{holdNote ? ` · ${holdNote}` : ''}</span> : null}
    </span>
  );
}
